import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { SGKB986AService, Sgkb986aResCtrSearchresultDto, Sgkb986aResponse, Sgkb986aRequest } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { SgkbConstains } from '../sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb986aService {
  /** お客さま情報検索結果のSubject */
  private _contractorResult$: Subject<Sgkb986aResponse> = new Subject<Sgkb986aResponse>();

  /**
   * お客さま情報検索結果のobservable提供
   *
   * @readonly
   * @memberof UsedSgkb986aService
   */
  get contractorValueChanges(): Observable<Sgkb986aResponse> {
    return this._contractorResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB986AService} sGKB986AService
   * @memberof InitialInfoService
   */
  constructor(private sGKB986AService: SGKB986AService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * お客さま情報検索API呼び出し
   *
   * @param {*} value
   * @memberof UsedSgkb986aService
   */
  searchContractor(value: any, noCheckError = false): Observable<Sgkb986aResponse> {
    // 空の契約お客さま番号リストのArrayを再設定する
    this.resetEmptyArray(value);

    return this.sGKB986AService.SGKB986APost(<Sgkb986aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          if (noCheckError) {
            this.apiCommonService.checkErrorNoSearchData(response);
          } else {
            this.apiCommonService.checkError(response);
          }

          if (response.body.ctrSearchresultList != null) {
            this._contractorResult$.next(this.setResponseInitialData(response.body));
          } else {
            response.body.ctrSearchresultList = [];
            this._contractorResult$.next(response.body);
          }
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB986A);
          return throwError(err.message);
        }));
  }

  /**
   * 空のArray要素の変換処理
   * [""] -> []
   *
   * @param {*} request
   * @memberof UsedSgkb986aService
   */
  resetEmptyArray(request: any): void {
    //nop
  }

  /**
   * レスポンスに対し、Array<Sgkb986aResponseCtrSearchResultDto>の初期表示値を作成
   *
   * @return {*}  {Sgkb986aResponse}
   * @memberof UsedSgkb986aService
   */
  setResponseInitialData(response: Sgkb986aResponse): Sgkb986aResponse {

    response.ctrSearchresultList.forEach((ctrSearchResultList) => {
      if (!ctrSearchResultList.description) {
        ctrSearchResultList.description = {
          srvCtrNo: "",
          firstSrvctrNo: "",
          recptFixNo: "",
          companycode: "",
          companyname: "",
          areacode: "",
          areaMei: "",
          prdCode: "",
          prdAname: "",
          prdRyaku: "",
          prdDispAname: "",
          srvClsfyCode: "",
          srvClsfyCodeAname: "",
          energyClscode: "",
          energyClsfyCodeaname: "",
          heat: "",
          heatAname: "",
          prdGoodsAname: "",
          prdGoodsRyaku: "",
          prdGoodsDisp: "",
          gyoshuLargebunrui: "",
          gyoshuLargebunruiAname: "",
          ctrstrDate: "",
          ctrendDate: "",
          ctrefctkiStrtdate: "",
          ctrExpireDate: "",
          sogoCtrDiv: "",
          combinedcontractDivCodeaname: "",
          sameLocationkey: "",
          retailequipmentSalesformcode: "",
          retailequipmentSalfrmCodeaname: "",
          transCode: "",
          transCodeAname: "",
          ksdateDiv: "",
          ksdateDivAname: "",
          basicKensinDay: "",
          cndtBusCode: "",
          cndtBusAname: "",
          siteiKensinDiv: "",
          siteiKensinDivAname: "",
          kensinSchdl: "",
        }
      }
      if (!ctrSearchResultList.ctrperInfo) {
        ctrSearchResultList.ctrperInfo = {
          visitNo: "",
          visitName: "",
          visitKanaName: "",
          telNoDiv1: "",
          telNoDiv1Aname: "",
          telNo1: "",
          telNoDiv2: "",
          telNoDiv2Aname: "",
          telNo2: "",
          telNoDiv3: "",
          telNoDiv3Aname: "",
          telNo3: "",
          extLinkId: "",
        }
      }
      if (!ctrSearchResultList.userInfo) {
        ctrSearchResultList.userInfo = {
          usingJuyoshaDiv: "",
          usingVisitKnjnm: "",
          usingVisitKananame: "",
          usingVisitTeldivision1: "",
          usevisitteldiv1Aname: "",
          usingVisitTel1: "",
          usingVisitTeldivision2: "",
          usevisitteldiv2Aname: "",
          usingVisitTel2: "",
          usingVisitTeldivision3: "",
          usevisitteldiv3Aname: "",
          usingVisitTel3: "",
        }
      }
      if (!ctrSearchResultList.empposInfo) {
        ctrSearchResultList.empposInfo = {
          extCnnctNo: "",
          addressCode: "",
          postalCode: "",
          description: "",
          mptAname: "",
          townAreaName: "",
          ooazaName: "",
          bantiGoubunptgouAname: "",
          supadrKanjiAname1: "",
          yagouAname: "",
        }
      }
    });
    return response;
  }
}

